import React from 'react';
import wppLogo from '../assets/images/wpp/logo_B.png';
import { useT } from '../i18n';

const MaintenancePage: React.FC = () => {
  const t = useT();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#000000',
        fontFamily: "'WPP', Arial, sans-serif",
        padding: '20px',
        textAlign: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Subtle background pattern */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.03) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.02) 0%, transparent 40%)',
          pointerEvents: 'none',
        }}
      />

      {/* Card */}
      <div
        style={{
          position: 'relative',
          backgroundColor: 'rgba(255, 255, 255, 0.97)',
          borderRadius: '16px',
          padding: '60px 48px',
          maxWidth: '460px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        }}
      >
        <img
          src={wppLogo}
          alt="WPP Enterprise Solutions"
          style={{ width: '200px', height: 'auto', marginBottom: '32px' }}
        />

        {/* Divider line */}
        <div
          style={{
            width: '40px',
            height: '3px',
            backgroundColor: '#ff7800',
            margin: '0 auto 32px',
            borderRadius: '2px',
          }}
        />

        <h1
          style={{
            fontSize: '24px',
            color: '#1a1a2e',
            margin: '0 0 12px 0',
            fontWeight: 700,
            letterSpacing: '-0.5px',
          }}
        >
          Sitio en mantenimiento
        </h1>

        <p
          style={{
            fontSize: '15px',
            color: '#6c757d',
            margin: '0 0 32px 0',
            lineHeight: '1.6',
          }}
        >
          {t('x.maintenance')}
          <br />
          {t('x.backSoon')}
        </p>

        {/* Status indicator */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: '#f0f4ff',
            padding: '8px 16px',
            borderRadius: '20px',
            fontSize: '13px',
            color: '#0B64D1',
            fontWeight: 500,
          }}
        >
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#0B64D1',
              animation: 'pulse 2s ease-in-out infinite',
            }}
          />
          {t('x.workingOnIt')}
        </div>
      </div>

      {/* Footer */}
      <p
        style={{
          position: 'relative',
          fontSize: '13px',
          color: 'rgba(255, 255, 255, 0.4)',
          marginTop: '32px',
          letterSpacing: '1px',
          textTransform: 'uppercase',
        }}
      >
        Deskbooking
      </p>

      {/* Pulse animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(0.8); }
        }
      `}</style>
    </div>
  );
};

export default MaintenancePage;
